module.exports = __webpack_public_path__ + "img/eye.fde986e6.svg";